import {
  BookOpen,
  HandHeart,
  Users,
  ShieldCheck,
} from "lucide-react";

export const stats = [
  { label: "Children Supported", value: "120+" },
  { label: "Meals Served Weekly", value: "840" },
  { label: "Education Sponsorships", value: "65" },
  { label: "Volunteer Hours", value: "1.8k" },
];

export const programs = [
  {
    icon: BookOpen,
    title: "Education Support",
    description:
      "School fees, learning materials, tutoring, and mentorship.",
  },
  {
    icon: HandHeart,
    title: "Daily Care",
    description:
      "Meals, shelter, healthcare, and emotional support.",
  },
  {
    icon: Users,
    title: "Community Outreach",
    description:
      "Partnerships with donors and local organizations.",
  },
  {
    icon: ShieldCheck,
    title: "Child Protection",
    description:
      "Safe and secure environment for every child.",
  },
];

export const testimonials = [
  {
    name: "Amina K.",
    role: "Volunteer",
    quote:
      "Every child is supported and encouraged here.",
  },
  {
    name: "David M.",
    role: "Donor",
    quote:
      "It's wonderful seeing the impact of every donation.",
  },
];

export const teamMembers = [
  {
    name: " Mrs.GERALDINE P. WAH",
    role: "Director",
    image: "/images/staf01.webp",
     bio: "She Provides strategic leadership and overall management of the orphanage by overseeing daily operations, supervising staff, ensuring the welfare and protection of children, managing partnerships with donors and stakeholders, and ensuring compliance with organizational policies and government regulations.",
  },
  {
    name: "Mrs. ROSE WAH ",
    role: "Founder",
    image: "/images/staf02.webp",
    bio: "Mrs Rose founded Dry My Tears with a vision to provide every vulnerable child with a loving home and access to quality education.",
    
  },
  {
    name: "Mr. MILLER SOWAH BAYE",
    role: "Accountant Manager",
    image: "/images/staf03.webp",
    bio: "Prepares and manages the orphanage's annual and monthly budgets by allocating funds to essential operational areas such as food, education, healthcare, staff salaries, and utilities, while monitoring expenditures to ensure financial accountability and efficient use of resources.",
  },
];